<template>
  <div class="hero">
      <div class="super">
          <img src="../../public/img/seafire_header_logo.svg" alt="">
      </div>
      <div class="duper">
          <h3>The artifact is bold, beautiful, brillantly designed software.</h3>
          <h1>The artform goes much deeper.</h1>
      </div>
  </div>
</template>

<script>
export default {
  name: "home"
};
</script>

<style lang="scss" scoped>
.hero {
  min-height: calc(100vh + 250px);
  background: #fff url("../../public/img/seafire_bg_06.jpg") no-repeat center top fixed;
  background-size: cover;
  position: relative;
        @media (max-width: 700px) {
  min-height: calc(100vh + 150px);
      }
/*  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    background: url("../../public/img/clouds_base.png") center top fixed;
    height: 100vh;
    width: 100vw;
    background-size: cover;
  }
  &:after {
    content: "";
    position: absolute;
    bottom: 0;
    background: url("../../public/img/mountains_1920_revised.png") center bottom;
    background-size: cover;
    height: 100vh;
    width: 100vw;
  } */
}

.super {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 64px;
  img {
    width: 121px;
    margin-bottom: 8px;
  }
  span {
    opacity: 0.6;
    color: #ffffff;
    font-family: Archia;
    font-size: 11.22px;
    letter-spacing: 2px;
    line-height: 24px;
  }
}

.duper {
  margin-top: 173px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
      @media (max-width: 700px) {
          margin-top: 56px;
      }
  h3 {
    margin: 0;
    opacity: 0.89;
    color: #ffffff;
    font-family: Archia;
    font-size: 32.93px;
    font-weight: 400;
    letter-spacing: 0.25px;
    line-height: 43px;
    @media (max-width: 700px) {
      font-size: 14px;
      padding: 0 16px;
    }
  }
  h1 {
    margin: 0;
    color: #ffffff;
    font-family: Archia;
    font-size: 68.54px;
    font-weight: bold;
    letter-spacing: -1.5px;
    line-height: 117px;
    @media (max-width: 700px) {
      font-size: 36px;
      padding: 0 16px;
      line-height: 36px;
    }
  }
}
</style>

